module.exports = __webpack_public_path__ + "img/logo.ec28bcb5.png";